(function (window, $, global ) { // eslint-disable-line
    $('.zm-card-document').on('click', '[js-show-options]', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).parents('.zm-card-document').toggleClass("is-active");
    });

    $('.zm-card-document').on('click', function(e) {
        var target = $(e.target).parents(".zm-card-document__options-menu")[0];

        if (target === undefined) {
            $(this).removeClass("is-active");
        }
    });

    $('.zm-card-document--image').click(function(e) {
        if ($(e.target).hasClass('zm-card-document--image')) {
            $(this).find(".card__figure-icon--zoom").trigger('click');
        }
    });

    $("[js-nav-zm-trigger]").click(function(e) {
        e.preventDefault();
        $(".main, body").toggleClass("nav-is-opened");
        $(".navigation__trigger").toggleClass("is-active");
        $("[js-nav-panel]").toggleClass("is-opened");
    });

    $("[js-zm-change-page]").change(function() {
        var url = $(this).val();
        if (url) {
            document.location.href = url;
        }
    });

    $("[js-mfp-youtube]").magnificPopup({
        type: "iframe"
    });

    $("[js-mfp-audio], [js-modal-landing]").magnificPopup({
        type: "inline"
    });

    $("[js-trigger-new-password]").click(function(e) {
        e.preventDefault();
        $(".gr-form__password").toggleClass("is-opened");
    });

    /* Forms */
    $('.js-zm-form').on('submit', function(e){
        e.preventDefault();
        var $form = $(this);
        var $loading = $form.find('button[type="submit"]');
        var $confirmation = $form.closest('div').find('.form-confirmation');
        var isFreeform = $form.is('[data-freeform]');

        $.ajax({
            url: $form.find('input[name="action"]').val(),
            dataType: 'JSON',
            type: 'POST',
            data: new FormData($form[0]),
            // Prevent jQuery from transforming the data into a query string
            // or worry about content type
            processData: false,
            contentType: false,
            cache: false,
            beforeSend: function() {
                $loading.addClass('icon-refresh processing');
            },
            success: function(data) {
                $('div.parsley-errors-list').remove();

                if (data.success) {
                    $confirmation.removeClass('is-hidden');
                    $form.hide();
                } else if (data.errors) {
                    $.each(data.errors, function(key, value) {
                        if (key === 'furnitures') {
                            var $furnitures = $form.find('div.furnitures-errors');
                            if ($furnitures.length > 0) {
                                $furnitures.append('<div class="parsley-errors-list">' + $furnitures.data('filetype-error') + '</div>');
                            }
                        } else {
                            var field = isFreeform ? $form.find('[name="' + key + '"], [name="' + key + '[]"]') : $form.find('[name="fields[' + key + ']"]');

                            if (field.length > 0) {
                                field.closest('div').append('<div class="parsley-errors-list">' + value + '</div>');
                            }
                        }
                    });
                }
            },
            complete: function() {
                $loading.removeClass('icon-refresh processing');
            }
        });
    });

}( window, jQuery, window.groots ));
